import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddBookComponent } from './add-book/add-book.component';
import { BookComponent } from './book/book.component';
import { BookListComponent } from './book-list/book-list.component';
import { EditBookComponent } from './edit-book/edit-book.component';
import { ModalBookComponent } from './modal-book/modal-book.component';
import { StatisticMemberComponent } from '../memberr/statistic-member/statistic-member.component';
import { ViewBookComponent } from './view-book/view-book.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import BookValidation from 'src/app/main/validations/BookValidation';
import { BookNumberComponent } from './book-number/book-number.component';
import { StatisticsBookComponent } from './statistics-book/statistics-book.component';
import { TagComponent } from './tag/tag.component';
import { CirculationHistoryComponent } from './circulation-history/circulation-history.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { UploadBookCoverComponent } from './upload-book-cover/upload-book-cover.component';
import { ImportBookComponent } from './import-book/import-book.component';
import { ToastrComponentlessModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AddBookComponent,
    BookComponent,
    BookListComponent,
    EditBookComponent,
    ModalBookComponent,
    StatisticsBookComponent,
    ViewBookComponent,
    BookNumberComponent,
    TagComponent,
    CirculationHistoryComponent,
    UploadBookCoverComponent,
    ImportBookComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CommonModule,
    NgxChartsModule,
    NgxDatatableModule,
    NgbModalModule,
    NgSelectModule,ToastrComponentlessModule
  ],
  providers: [BookValidation],
})
export class BookModule {}